import { defineStore } from 'pinia'
import Network from '@/Network'

import { CreateShift } from '@/Network/Types/Requests/ShiftRequests'
import { ListShiftResponse, ShiftResponse } from '@/Network/Types/Responses/ShiftResponses'

export type ShiftState = {
  shifts: ListShiftResponse | undefined
  listShifts: ShiftResponse[]
}

export const useShiftStore = defineStore('shift', {
  state: (): ShiftState => ({
    shifts: undefined,
    listShifts: []
  }),
  actions: {
    async getAllShifts(): Promise<void> {
      const data = await Network.shift.list()
      this.shifts = data
      this.listShifts = this.shifts.data
    },

    async create(payload: CreateShift) {
      await Network.shift.create(payload)
    },

    async remove(shiftId: number): Promise<void> {
      await Network.shift.remove(shiftId)
    },

    async update({ shiftId, payload }: { shiftId: number; payload: CreateShift }): Promise<void> {
      await Network.shift.update(shiftId, payload)
    },

    async fetchByScheduleId(scheduleId: number): Promise<void> {
      const data = await Network.shift.getByScheduleId(scheduleId)
      this.listShifts = data.data
    },

    async setShiftsBySchedules(scheduleIds: number[] | null) {
      if (!scheduleIds?.length) {
        this.listShifts = []
        return
      }

      await this.getAllShifts()

      const shifts =
        this.shifts?.data?.filter((s) => s.schedule && scheduleIds.includes(s.schedule.id)) || []

      this.listShifts = shifts
    }
  }
})
